import { useContext } from 'react';
import { PartialDeep } from 'type-fest';

import { PortalPublicConfigurationModel } from '@portal-clients/configuration';

import { PortalPublicConfigurationContext } from './portal-public-configuration-context';

export const usePortalPublicConfiguration =
  (): PartialDeep<PortalPublicConfigurationModel> & { portalId: string } => {
    const context = useContext(PortalPublicConfigurationContext);

    if (!context) {
      throw new Error(
        'usePortalPublicConfiguration must be used within a PortalConfigurationProvider',
      );
    }

    return context;
  };
